import { useComputedColorScheme } from "@mantine/core";
import { useEffect } from "react";

const safeAreaModule =
	import.meta.env.VITE_CAPACITOR_BUILD === "true"
		? import("@capacitor-community/safe-area")
		: null;

// Edge-to-edge system bars are transparent and default to the OS theme, so their content
// must follow the in-app color scheme or it becomes unreadable (e.g. light icons on a light app).
export function SystemBarsColorSchemeSync() {
	const computedColorScheme = useComputedColorScheme("light", {
		getInitialValueInEffect: false,
	});

	useEffect(() => {
		safeAreaModule?.then(({ SafeArea, SystemBarsStyle }) =>
			SafeArea.setSystemBarsStyle({
				style:
					computedColorScheme === "dark"
						? SystemBarsStyle.Dark
						: SystemBarsStyle.Light,
			}),
		);
	}, [computedColorScheme]);

	return null;
}
